import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { FileSetEntryViewModel, ImportOrigin, InstanceModel, StatePropertyValueModel } from '../../shared/fs.model';
import { isGuid } from '../../shared/utils';
import { FilesetService } from '../resource/fileset.service';
import { FileSetError, ValidatorService } from './validator.service';

export interface FileSetValidationResult {
  State: InstanceModel, 
  Errors: FileSetError[]
}

@Injectable()
export class FilesetValidatorService {
  constructor(
    private validatorService: ValidatorService,
    private filesetService: FilesetService
  ) { }

  public validateFileset(filesetId: string, insId?: string, inState?: InstanceModel, requiredStatusId?: string): Observable<FileSetValidationResult> {
    if (inState && inState.State) {
      return of(this.validateInstanceModel(inState, requiredStatusId));
    }
    else if (isGuid(insId)) {
      return this.filesetService.getInstance(insId).pipe(
        map((data: any) => {
          return this.validateInstanceModel(data, requiredStatusId);
        }),
        catchError(() => of({State: null, Errors:null}))
      )

    } else if (isGuid(filesetId)) {
      return this.filesetService.getTemplate(filesetId).pipe(
        map((data: any) => {
          return this.validateInstanceModel(data, requiredStatusId);
        }),
        catchError(() => of({State: null, Errors:null}))
      );
    } else {
      return of({State: null, Errors:null});
    }
  }

  private validateInstanceModel(data: InstanceModel, requiredStatusId: string) {
    let files = this.convertData(data);
    this.validatorService.setAndUpdateInstanceState(data, requiredStatusId, requiredStatusId ? true : false);
    this.validatorService.validateInstanceData(files);

    return {
      State: data,
      Errors: this.validatorService.errors
    };
  }

  private convertData(data: InstanceModel): FileSetEntryViewModel[] {
    let files = [];
    if (data.State.FileStates && data.State.FileStates.length) {
      let fileNames = data.Context.MetaDataCache.reduce((obj, item) => (obj[item.EntryId] = item["Name"], obj), {});
      files = data.State.FileStates.map(state => {
  
        let name = fileNames[state.FileId];
        return {
          id: state.FileId, 
          name: name ?? state.FileId,
          docType: state.FileStateValues.find(sVal => sVal.StateKey == "type")?.Value, 
          status: state.FileStateValues.find(sVal => sVal.StateKey == "status")?.Value,
          properties: {},
          importOrigin: state.FileStateValues.find(sVal => sVal.StateKey == "importorigin")?.Value as ImportOrigin
        }
      });
    }

    return files;
  }

}
